import { cn } from "../lib/utils";

interface SkeletonMessageProps {
	isUser?: boolean;
}

export function SkeletonMessage({ isUser = false }: SkeletonMessageProps) {
	return (
		<div className={cn("flex gap-3 px-4 py-3 sm:px-6", isUser ? "flex-row-reverse" : "flex-row")}>
			<div
				className={cn(
					"shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full animate-pulse",
					isUser ? "bg-primary/30" : "bg-card border border-border"
				)}
			/>
			<div className={cn("flex-1 min-w-0", isUser ? "max-w-[75%]" : "max-w-[85%]")}>
				<div
					className={cn(
						"space-y-2 px-3.5 py-2.5 sm:px-4 sm:py-3 rounded-2xl",
						isUser ? "bg-primary/20 rounded-tr-sm" : "bg-card border border-border rounded-tl-sm"
					)}
				>
					<div className="h-3 bg-secondary/50 rounded animate-pulse w-3/4" />
					<div className="h-3 bg-secondary/50 rounded animate-pulse w-1/2" />
					<div className="h-3 bg-secondary/50 rounded animate-pulse w-5/6" />
				</div>
			</div>
		</div>
	);
}

export function SkeletonList({ count = 3 }: { count?: number }) {
	return (
		<div className="space-y-1 py-4">
			{Array.from({ length: count }).map((_, i) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton items, never reorder
				<SkeletonMessage key={i} isUser={i % 2 === 0} />
			))}
		</div>
	);
}
